import { IPostComment } from './ipostcomment';

export interface IPostCommentState {
    postComment: IPostComment,
    postComments: Array<IPostComment>,
    error?: any
}
